import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRef } from "react";

import { APP_SETTINGS_CACHE_KEYS } from "./keys";

import { AppSettingsRepository } from "@/repositories/app-settings";
import { UpdateAppSettings } from "@/types";

export const useUpdateAppSettings = () => {
  const queryClient = useQueryClient();
  const appSettingsRepository = useRef(new AppSettingsRepository());

  return useMutation({
    mutationFn: (data: UpdateAppSettings) =>
      appSettingsRepository.current.update(data),
    onSuccess: (settings) =>
      queryClient.setQueryData(APP_SETTINGS_CACHE_KEYS.DETAIL, settings),
  });
};
